import { render, staticRenderFns } from "./NoActionVisitsComponent.vue?vue&type=template&id=5ee775db&scoped=true&"
import script from "./NoActionVisitsComponent.vue?vue&type=script&lang=js&"
export * from "./NoActionVisitsComponent.vue?vue&type=script&lang=js&"
import style0 from "./NoActionVisitsComponent.vue?vue&type=style&index=0&id=5ee775db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee775db",
  null
  
)

export default component.exports